import React from 'react';

export default function CourseFilters({ subjects, selectedSubject, onSelectSubject }) {
  const baseAll = 'px-6 py-2 rounded-full font-medium transition-all';
  const cls = (active, extra = '') =>
    `${baseAll} ${
      active
        ? 'bg-purple-600 text-white shadow-lg shadow-purple-500/50 scale-105'
        : 'bg-gray-800 text-gray-200 hover:bg-gray-700 border border-gray-700'
    } ${extra}`;

  return (
    <div className="flex flex-wrap gap-3 justify-center mb-12">
      <button
        onClick={() => onSelectSubject('all')}
        data-testid="filter-all-subjects"
        className={cls(selectedSubject === 'all')}
      >
        All Subjects
      </button>
      <button
        onClick={() => onSelectSubject('FREE')}
        data-testid="free-only-filter"
        className={`${baseAll} border-2 ${
          selectedSubject === 'FREE'
            ? 'bg-green-600 text-white shadow-lg shadow-green-500/50 scale-105 border-green-400'
            : 'bg-gray-800 text-gray-200 hover:bg-gray-700 border-green-600/50'
        }`}
      >
        🎓 FREE Only
      </button>
      {subjects.map((subject) => (
        <button
          key={subject}
          onClick={() => onSelectSubject(subject)}
          data-testid={`filter-subject-${subject.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          className={cls(selectedSubject === subject)}
        >
          {subject}
        </button>
      ))}
    </div>
  );
}
